import { render, staticRenderFns } from "./PatientViewer.vue?vue&type=template&id=1fc67cd9&"
import script from "./PatientViewer.vue?vue&type=script&lang=ts&"
export * from "./PatientViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports